module.exports = __webpack_public_path__ + "img/cooperationContentImg4.ec6c6528.png";